<template>
  <div class="mapview" id="mapview">
    <view2d v-if="mapviewState.mode = '2d'"></view2d>
  </div>
</template>

<script>
import { store } from "@/store";
import View2D from "@/components/View2D";

export default {
  name: "MapView",

  components:{
    'view2d': View2D,
  },

  data() {
    return {
      folderId: this.$route.params.folderId,
      mapviewState: store.state.mapview,
    };
  },

  methods: {
  },

  created() {
    store.updateMapViewMode("2d");
    store.updateMapViewFolderId(this.folderId);

    this.axios.get("/api/whole/folder/" + this.folderId).then((response) => {
      const data = response.data;
      store.updateMapViewWholeInfo(data);

      const breadcrumbs = [
        {
          text: "発電所一覧",
          disabled: false,
          exact: true,
          to: "/plant",
        },
        {
          text: data.plant.name,
          disabled: false,
          exact: true,
          to: "/plant/" + data.plant.id + "/folder",
        },
      ];
      store.updateMapViewBreadcrumbs(breadcrumbs);
    });
  },
};
</script>
<style >
.mapview {
  width: 100%;
  height: 100%;
}
</style>
